// extracted by mini-css-extract-plugin
module.exports = {"speed-menu-container":"speed-menu-container-ABjzc","title":"title-Hu2Dm","options-container":"options-container-DNn3D","option":"option-GcPlB"};